module.exports = __webpack_public_path__ + "static/media/citytour.0069772c.jpg";